import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

import { Observable } from 'rxjs/Observable';

import { BaseHttpService } from './base-http.service';
import { EventRequestModel, Permission, AcknowledgementPermission, EventRequestChangeStatusType, EventRequesAcknowledgeModel, EventRequesAcknowledgeListModel, RequestBuildingUnitView, CompanyBuildingUnitView, PaginationModel, PagedResult, EventRequestTotals, EventRequestAutocomplete, VenueMeetingItem, RequestCharge } from '../models';

@Injectable()
export class EventService extends BaseHttpService<any> {

  constructor(private http: HttpClient) {
    super('events');
  }
  ApproveEventStatus(requestId: EventRequestChangeStatusType) {
    return this.http
      .post(this.getApiURI() + '/events/ApproveEventStatus',requestId)
      .catch(this.handleError)
  }

  ReturnEventStatus(requestId: EventRequestChangeStatusType) {
    return this.http
      .post(this.getApiURI() + '/events/ReturendEventStatus', requestId )
      .catch(this.handleError)
  }
  ReturnEventStatusByTenant(requestId: EventRequestChangeStatusType) {
    return this.http
      .post(this.getApiURI() + '/events/ReturnedEventStatusByTenant',  requestId)
      .catch(this.handleError)
  }

  getEventLocation(requestId: number): Observable<CompanyBuildingUnitView[]>  {
    return this.http
      .post(this.getApiURI() + '/events/GetLocations', JSON.stringify({ requestId }))
      .catch(this.handleError)
  }
  getEventAdsLocation(requestId: number): Observable<CompanyBuildingUnitView[]> {
    return this.http
      .post(this.getApiURI() + '/events/GetAdsLocations', JSON.stringify({ requestId }))
      .catch(this.handleError)
  }

  getEventAcknowledgementList(requestId: number): Observable<EventRequesAcknowledgeListModel[]> {
    return this.http
      .post(this.getApiURI() + '/events/GetAcknowledgementListToTSD', JSON.stringify({ requestId }))
      .catch(this.handleError)
  }
  RejectEventStatus(requestId: EventRequestChangeStatusType) {
    return this.http
      .post(this.getApiURI() + '/events/RejectEventStatus',requestId )
      .catch(this.handleError)
  
  }

  ApproveEventAcknowledgementStatus(model: EventRequestChangeStatusType) {
    return this.http
      .post(this.getApiURI() + '/events/ApproveEventAcknowledgementStatus', model )
      .catch(this.handleError)
  }


  RejectEventAcknowledgementStatus(model: EventRequestChangeStatusType) {
    return this.http
      .post(this.getApiURI() + '/events/RejectEventAcknowledgementStatus',model )
      .catch(this.handleError)

  }

  AddEventAcknowledgementList(model: EventRequesAcknowledgeModel) {
    return this.http
      .post(this.getApiURI() + '/events/CreateEventAcknowledgementRequest', JSON.stringify(model))
      .catch(this.handleError)
  }


  AddEventRequest(formData: FormData):Observable<EventRequestModel> {
    return this.http
      .post(this.getApiURI() + '/events/AddEvent', formData, { headers: new HttpHeaders({ 'RequestWithFiles': 'RequestWithFiles' }) })
      .catch(this.handleError)

  }
  ApproveEventStatusByTenant(requestId: EventRequestChangeStatusType) {
    return this.http
      .post(this.getApiURI() + '/events/ApproveEventStatusByTenant', requestId )
      .catch(this.handleError)
  }
  RejectEventStatusByTenant(requestId: EventRequestChangeStatusType) {
    return this.http
      .post(this.getApiURI() + '/events/RejectEventStatusByTenant', requestId )
      .catch(this.handleError)

  }

  UpdateEventRequest(formData: FormData): Observable<EventRequestModel> {
    return this.http
      .post(this.getApiURI() + '/events/UpdateEvent', formData, { headers: new HttpHeaders({ 'RequestWithFiles': 'RequestWithFiles' }) })
      .catch(this.handleError)

  }


  getAcknowledgementEvent(model: AcknowledgementPermission): Observable<EventRequestModel[]> {
    return this.http
      .post(this.getApiURI() + '/events/GetAcknowledgementEvents', JSON.stringify(model))
      .catch(this.handleError)
  }

  getAcknowledgementPermission(): Observable<Permission[]> {
    return this.http
      .get(this.getApiURI() + '/permissions/GetAcknowledgementPermission')
      .catch(this.handleError)
  }
  getEvents(model: { paginationModel: PaginationModel, pendingOnly: boolean, requestStatusId: number, requestNo: string ,requestId:number}): Observable<PagedResult<EventRequestModel>> {
    return this.http
      .get(this.getApiURI() + '/events/GetEvents' + `?pagingParameters.pageNumber=${model.paginationModel.pageNumber}&pagingParameters.pageSize=${model.paginationModel.pageSize}&pagingParameters.orderBy=${model.paginationModel.orderBy}&pendingOnly=${model.pendingOnly}&requestStatusId=${model.requestStatusId}&requestNo=${model.requestNo}&requestId=${model.requestId}`)
      .catch(this.handleError)
  }
  getEventsAcknowledge(model: { paginationModel: PaginationModel, pendingOnly: boolean, requestStatusId: number, requestNo: string, requestId: number }): Observable<PagedResult<EventRequestModel>> {
    return this.http
      .get(this.getApiURI() + '/events/GetEventsForAcknowledgement' + `?pagingParameters.pageNumber=${model.paginationModel.pageNumber}&pagingParameters.pageSize=${model.paginationModel.pageSize}&pagingParameters.orderBy=${model.paginationModel.orderBy}&pendingOnly=${model.pendingOnly}&requestStatusId=${model.requestStatusId}&requestNo=${model.requestNo}&requestId=${model.requestId}`)
      .catch(this.handleError)
  }
  deleteCompanyBuildingUnit(eventId: number, companyBuildingUnitId: number) {
    return this.http
      .delete(this.getApiURI() + `/events/${eventId}/buildingunits/${companyBuildingUnitId}`)
      .catch(this.handleError);
  }
  deleteFile(model: { requestId: number, appFileId: number }) {
    const url = this.getApiURI() + `/request/${model.requestId}/eventFiles/${model.appFileId}`;
    // Process the file downloaded
    return this.http.delete(url)
      .catch(this.handleError);
  }
  GetEventTotalsReport(): Observable<EventRequestTotals[]> {
    return this.http
      .get(this.getApiURI() + '/events/GetEventTotalsReport')
      .catch(this.handleError)
  }
  GetEventsAutocomplete(): Observable<EventRequestAutocomplete[]> {
    return this.http
      .get(this.getApiURI() + '/events/GetEventsAutocomplete')
      .catch(this.handleError)
  }
  ReplaceFile(formData: FormData): Observable<any> {
    return this.http
      .post(this.getApiURI() + '/events/ReplaceRequestFile', formData, { headers: new HttpHeaders({ 'RequestWithFiles': 'RequestWithFiles' }) })
      .catch(this.handleError)
  }

  CancelEventRequestByTenant(model: EventRequestChangeStatusType) {
    return this.http
      .post(this.getApiURI() + '/events/CancelEventRequest', model)
      .catch(this.handleError)

  }
}



// WEBPACK FOOTER //
// ./src/app/core/data/event.service.ts